import { render, staticRenderFns } from "./CollectionBigScreen.vue?vue&type=template&id=31464d77&scoped=true&"
import script from "./CollectionBigScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBigScreen.vue?vue&type=style&index=0&id=31464d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31464d77",
  null
  
)

export default component.exports